// extracted by mini-css-extract-plugin
module.exports = {"root":"TeamTable_root__1XgCQ","row":"TeamTable_row__1dNwe"};